$(document).ready(function () {

    function mmenuw() {
        //Menu menu
        var wi = $(window).width();
        if (wi <= '1042') {
            $(".head-r ul, .hp_topbar .hp_menu").addClass("js-menu").addClass("sliding-panel-content");

            $('.sliding-panel-button,.sliding-panel-fade-screen,.sliding-panel-close').on('click touchstart', function (e) {
                $('.sliding-panel-content,.sliding-panel-fade-screen').toggleClass('is-visible');
                e.preventDefault();
            });
        }
        //Mobile register accordion
        if (wi <= '599') {
            $('.js-accordion-trigger').unbind('click').bind('click', function (e) {
                // Close all
                $('.acc-forms').slideUp('slow');
                $('.form-container .signup_form').removeClass('is-expanded');
                $('.form-container .signin_form').removeClass('is-expanded');
                //
                jQuery(this).parent().find('.acc-forms').slideToggle('slow');
                jQuery(this).parent().toggleClass('is-expanded');
                e.preventDefault();
            });
        }
    }

    mmenuw();
    $(window).resize(function () {
        mmenuw();
    });

    $(window).ready(function () {
        $(window).scroll(function () {
            if ($(this).scrollTop() > $('.brand_about').height()) {
                $('.main_info .publish-btn').hide();
                $('.head-l .publish-btn').show();
                $('.main_info .publish-btn').stop().animate({opacity: 0}, 500);
                $('.head-l .publish-btn').stop().animate({opacity: 1}, 500);
            } else {
                $('.main_info .publish-btn').show();
                $('.head-l .publish-btn').hide();
                $('.main_info .publish-btn').stop().animate({opacity: 1}, 500);
                $('.head-l .publish-btn').stop().animate({opacity: 0}, 500);
            }
        });

        $(window).scroll(function () {
            if ($(this).scrollTop() > $('.brand_about').height()) {
                $('.custplace-logo').hide();
                $('.cust-circle').hide();
                $('.brand-radius').show();
                $('.head-l .brand-badge').show();
                $('.custplace-logo').stop().animate({opacity: 0}, 500);
                $('.cust-circle').stop().animate({opacity: 0}, 500);
                $('.brand-radius').stop().animate({opacity: 1}, 500);
                $('.head-l .brand-badge').stop().animate({opacity: 1}, 500);
            } else {
                $('.custplace-logo').show();
                $('.cust-circle').show();
                $('.brand-radius').hide();
                $('.head-l .brand-badge').hide();
                $('.custplace-logo').stop().animate({opacity: 1}, 500);
                $('.cust-circle').stop().animate({opacity: 1}, 500);
                $('.brand-radius').stop().animate({opacity: 0}, 500);
                $('.head-l .brand-badge').stop().animate({opacity: 0}, 500);
            }
        });

        // Dots dropdown-button
        $(document).on('click', '.dots', function () {
            var $button, $menu;
            $button = $(this);
            $menu = $button.siblings(".dropdown-menu");
            $menu.toggleClass("show-menu");
            $menu.children("li").click(function() {
                $menu.removeClass("show-menu");
            });
            return false;
        });

        // Tooltip
        if(navigator.userAgent.match(/iPhone/i) == null && navigator.userAgent.match(/iPad/i) == null) {
            $(document).tooltip({
                items: "[data-title]",
                position: {
                    my: "center bottom-10",
                    at: "center top",
                    using: function (position, feedback) {
                        $(this).css(position);
                        $("<div>")
                            .addClass("arrow")
                            .addClass(feedback.vertical)
                            .addClass(feedback.horizontal)
                            .appendTo(this);
                    }
                },
                content: function () {
                    return $(this).data('title');
                }
            });
        }

        // User menu
        $('.user-avatar').click(function() {
            $('.user_menu').css('display', ($('.user_menu').css('display') == 'block') ? 'none': 'block');
        });
    });

    // Search brands
    if ($("#searchbrands input").length) {
        $("#searchbrands input").autocomplete({
            source: "/search",
            minLength: 2,
            search: function () {
                $(this).addClass('working');
            },
            select: function (event, ui) {
                $(".searchterm").val(ui.item.label);
                if (ui.item.slug == 'add_business') {
                    $(location).attr('href', "https://business.custplace.com/espace-certification/?utm_source=custplace&utm_medium=header_search");
                } else {
                    $(location).attr('href', "/" + ui.item.slug);
                }
                return false;
            }
        });
    }

    // Modal close function
    $(".modal-close").click(function () {
        $(".modal-state:checked").prop("checked", false).change();
        $("body").removeClass("modal-open");
    });

    // Display warning message once if exists
    if ($('#warning-message').length) {
        var top = 25 + $('header').height() + $('section.brand-infos').height();
        // For mobile
        if ($(window).width() <= 694) {
            top += 90;
        }
        $('#warning-message').css('top', top);
        $('#warning-message').fadeIn();
    }

    // Close warning message
    $('span[data-click="closeWarning"]').click(function() {
        $(".warning-notice").fadeOut("slow");
    });

    // Close cookie alert
    $("span.close_cookies_btn").click(function() {
        $('div.cookies').remove();
    });
});
